"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
function usePatchElement() {
    var _a = tslib_1.__read(React.useState([]), 2), elements = _a[0], setElements = _a[1];
    var patchElement = React.useCallback(function (element) {
        // append a new element to elements (and create a new ref)
        setElements(function (originElements) { return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(originElements), false), [element], false); });
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return function () {
            setElements(function (originElements) { return originElements.filter(function (ele) { return ele !== element; }); });
        };
    }, []);
    return [elements, patchElement];
}
exports.default = usePatchElement;
//# sourceMappingURL=usePatchElement.js.map